<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label [innerHtml]="question?.question_copy || question?.email_version"></label>
  }
  <!--<div class="row row--xs">
  <div *ngFor="let option of items; let i = index;" class="col-6">
    <label class="custom-input custom-input--buttons">
      <input [checked]="option.answer === question?.answer || i === 0" (change)="checkRadio(option.answer)" type="radio" [name]="uniqueControlName" [value]="option.answer" />
      <span class="custom-input__label">
        <svg class="icon">
          <use attr.xlink:href="{{option.icon}}"></use>
        </svg>
        {{option.answer}}
      </span>
    </label>
  </div>
</div>-->
@if (showSkip) {
  <div class="question-skip">
    <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
      <input
        type="checkbox"
        [checked]="skipped"
        [(ngModel)]="skipped"
        (ngModelChange)="onSkipChange()"
        name="add-note-toggle"
        id="skip-driver-details-toggle">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">Skip for now</span>
      </label>
    </div>
  }
  <div class="row row--xs">
    @for (option of items; track option) {
      <div class="col-6">
        <label
          class="custom-input custom-input--buttons"
          >
          <input [checked]="option.answer === question?.answer" (change)="checkRadio(option.answer)" type="radio" [name]="uniqueControlName" [value]="option.answer" />
          <span class="custom-input__label">
            <svg class="icon"><use attr.xlink:href="{{option.image_url}}"></use></svg>{{option.answer}}
          </span>
        </label>
      </div>
    }
  </div>
</div>
